<template>
  <roe-error-message :field="design.service_requirement_measurement_number">
    <input
      type="number"
      v-model.number="design.$model.service_requirement_measurement_number"
      required
      @change="updateRequirementConnectedModels()"
    />
    <label class="input-label-inside">months</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeServiceRequirementMonthsInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    updateRequirementConnectedModels() {
      if (
        +this.design.$model.service_requirement_employer_match === 1 ||
        +this.design.$model.service_requirement_sync === 1
      ) {
        this.design.$model.service_requirement_match_measurement_number = this.design.$model.service_requirement_measurement_number;
      }
      if (+this.design.$model.service_requirement_profit_sharing === 1) {
        this.design.$model.service_requirement_profit_sharing_measurement_number = this.design.$model.service_requirement_measurement_number;
      }
    }
  }
};
</script>
